import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=ada713c4"
import script from "./left-menu.vue?vue&type=script&lang=js"
export * from "./left-menu.vue?vue&type=script&lang=js"
import style0 from "./left-menu.vue?vue&type=style&index=0&id=ada713c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports